<template>
  <div>
    <v-radio-group v-model="direction">
      <v-radio
        v-for="(direction,i) in directions"
        :key="i"
        :label="direction"
        :value="direction"
      />
    </v-radio-group>
    <AccessPermitRequestGatePass />
    <GenericTextField
      :model="gate_in.bill_of_lading_number"
      label="Bill of lading #"
    />
    <v-file-input
      accept="image/*"
      label="Document of Terminal Operator"
      show-size
    />
    <v-textarea
      v-model="gate_in.details_of_visit"
      label="Details of visit"
      outlined
    />
  </div>
</template>

<script>
import GenericTextField from './GenericTextField';

export default {
  name: 'AccessPermitRequestVehicle',
  components: {
    GenericTextField,
  },
  data: () => ({
    gate_in: {
      bill_of_lading_number: '',
      vehicle: {
        number_plate: '',
        driver: {
          sur_name: '',
          given_name: '',
        },
      },
      details_of_visit: '',
    },
    gate_out: {

    },
    direction: '',
    directions: [
      'In',
      'Out',
    ],
  }),
};
</script>

<style scoped>

</style>
